import NombreFundemas from "../assets/images/Fundemas_LogoBl.png"
import ConectaCrecer from "../assets/images/ConectaCrecer_Blanco.png";
import LogoFooter from "../assets/images/Fundemas_Logo4.png";

export default function ImagesLogin() {
	return (
		<div className="flex flex-row md:flex-col items-center justify-between h-full">
			<div className="w-full flex justify-center">
				<img alt="" src={NombreFundemas} className="md:h-24 md:mt-10 w-4/5 md:w-auto" />
			</div>
			<div className="w-full flex justify-center">
				<img alt="" src={ConectaCrecer} className="md:w-3/4 w-2/3 " />
			</div>
			<div className="hidden w-full md:flex justify-center">
				<img alt="" src={LogoFooter} className = "h-20" />
			</div>
		</div>
	)
};
